import { Button, Modal, ModalBody } from "flowbite-react";
import { useRef, useState } from "react";
import { toast } from "react-toastify";
import { TermsContent, exportTermsToPdf } from "./ModalTerms";
import { useApplication } from "../../contexts/ApplicationContext";
import { useEffectiveContract } from "../../hooks/useEffectiveContract";

export function ModalContract({ isOpen, onClose }) {
  const [isExporting, setIsExporting] = useState(false);
  const contractRef = useRef(null);
  const { user } = useApplication();
  /* Mesmo documento do aceite: o contrato do representante acima, ou o padrão
     do sistema. Buscado quando o modal abre — reler a cada abertura é de
     propósito, para quem já aceitou enxergar a versão vigente. */
  const { contract, loading } = useEffectiveContract(isOpen);

  const handleExportPdf = async () => {
    try {
      setIsExporting(true);
      await exportTermsToPdf(contractRef.current, "termos-de-uso.pdf");
    } catch (error) {
      console.error("Erro ao exportar os termos em PDF:", error);
      toast.error("Não foi possível exportar o PDF. Tente novamente.");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Modal show={isOpen} onClose={onClose} size="5xl">
      <ModalBody className="p-0">
        <div
          ref={contractRef}
          data-terms-scroll-container
          className="max-h-[70vh] overflow-y-auto bg-slate-100/60 p-4"
        >
          <div className="mx-auto max-w-3xl rounded-lg border border-slate-200 bg-white shadow-sm">
            {loading ? (
              <div className="px-5 py-16 text-center text-[13px] text-slate-500 sm:px-10">
                Carregando o contrato...
              </div>
            ) : (
              <TermsContent
                typePayment={user?.Company?.typePayment}
                contract={contract}
              />
            )}
          </div>
        </div>
      </ModalBody>
      <Modal.Footer className="flex justify-center pt-2 pb-3">
        <Button
          color="light"
          onClick={handleExportPdf}
          disabled={isExporting}
          isProcessing={isExporting}
        >
          Exportar PDF
        </Button>
        <Button onClick={onClose}>Fechar</Button>
      </Modal.Footer>
    </Modal>
  );
}
